import * as React from "react";
import { forwardRef } from "react";
const SvgLock = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 68 100", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "m60.5 41.34v-14.84a26.5 26.5 0 0 0 -53 0v14.84l-7.5.66v55l34 3 34-3v-55zm-45-.71v-14.13a18.5 18.5 0 0 1 37 0v14.13l-18.5-1.63z" }));
const ForwardRef = forwardRef(SvgLock);
export default ForwardRef;
